export const isExternalUrl = (url: string) => url.match(/http[s]?\:\/\//i);
export const getQueryParams = (query: string) => new URLSearchParams(query);
